module.exports = __webpack_public_path__ + "static/media/thig_logo.dee1d7e5.png";